import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { Section, Inner, SectionTitle } from './shared';
import { media } from '../../styles/style-utils';
import introIcon from '../../assets/images/home/intro-icon.svg';

const Wrapper = styled(Section)`
  padding-top: 72px;
  padding-bottom: 72px;
  background-color: var(--b-white);
  color: var(--b-black);

  ${media.medium`
    padding-top: 120px;
    padding-bottom: 124px;
  `};
`;

const Row = styled(Inner)`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${media.medium`
    display: block;
  `};
`;

const Mark = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;

  ${media.medium`
    position: absolute;
    right: 0;
    bottom: -104px;
  `};

  i {
    display: block;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background-color: var(--b-black);
  }

  img {
    display: block;
    width: 101px;
    height: 55px;
  }
`;

const Intro = ({ title, large }) => (
  <Wrapper>
    <Row>
      <SectionTitle className={large ? 'large' : undefined}>
        {title || (
          <FormattedMessage
            id="home.intro.title"
            defaultMessage="For the curious, the devoted,{br}and the artists behind it all."
            values={{ br: <br /> }}
          />
        )}
      </SectionTitle>
      <Mark aria-hidden="true">
        <i />
        <img src={introIcon} alt="" />
      </Mark>
    </Row>
  </Wrapper>
);

Intro.propTypes = {
  title: PropTypes.node,
  large: PropTypes.bool,
};

export default Intro;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/home/Intro.js